<template>
  <div class="container">
    <app-header title="人工配送" :is-back="isBack" @back="back"/>
    <div>
      <div class="header1">
        <div class="message">送货人：<span>{{order.freightName}}</span></div>
        <div class="message">手机号码：<span>{{order.freightTel}}</span></div>
        <div class="message">车牌号码：<span>{{order.freightCode}}</span></div>
        <div class="message">配送员：<span>{{order.delivery}}</span></div>
        <div class="message">审核人：<span>{{order.reviewer}}</span></div>
        <div class="message">发货人：<span>{{order.consignor}}</span></div>
      </div>
    </div>
    <empty title="暂无订单信息" v-if="order == null"/>
  </div>
</template>

<script>
    import { getOrderDetail } from '@/api/order'
    export default {
        name: "logistics",
        data(){
            return{
              isBack: false,
              orderStatus: 0,
               order: {
                 freightName: ''
               }
            }
        },
        created() {
          this.orderStatus = this.$route.query.orderStatus
          this.getDetailInfo()
        },
        methods:{
          back(){
            this.$route.params.orderStatus = this.orderStatus
            this.$route.query.orderStatus = this.orderStatus
            this.$router.go(-1)
          },
          getDetailInfo() {
            getOrderDetail({id : this.$route.query.orderId}).then(res => {
              if (res.success) {
                this.order = res.data
              }
            })
          },
        }
    }
</script>

<style lang="less" scoped>
  .container{
    .header1{
      padding-bottom: 15px;
    }
    .message{
      padding-left: 12px;
      padding-right: 12px;
      padding-top: 6px;
      font-size:14px;
      font-family:PingFang SC;
      font-weight:400;
      line-height:20px;
      opacity:1;
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/order/logisticsRenGon.vue